import * as defaultServices from "./internal/defaultServices.js";
import * as internal from "./internal/tracer.js";
/**
 * @since 2.0.0
 */
export const TracerTypeId = internal.TracerTypeId;
/**
 * @since 2.0.0
 * @category tags
 */
export const ParentSpan = internal.spanTag;
/**
 * @since 2.0.0
 * @category tags
 */
export const Tracer = internal.tracerTag;
/**
 * @since 2.0.0
 * @category constructors
 */
export const make = internal.make;
/**
 * @since 2.0.0
 * @category constructors
 */
export const externalSpan = internal.externalSpan;
/**
 * @since 2.0.0
 * @category constructors
 */
export const tracerWith = defaultServices.tracerWith;
/**
 * @since 3.12.0
 * @category annotations
 */
export const DisablePropagation = internal.DisablePropagation;
//# sourceMappingURL=Tracer.js.map